module.exports = __webpack_public_path__ + "img/profess3.928cfa42.png";